import { render } from "./TheTruong_LopHoc.vue?vue&type=template&id=0fe2b8c0"
import script from "./TheTruong_LopHoc.vue?vue&type=script&lang=js"
export * from "./TheTruong_LopHoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__